module.exports = require("./../../_gen/starling/utils/Pool");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/Pool.js
// module id = 251
// module chunks = 0